<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="primary" v-b-tooltip.hover :title="showToolTip ? 'Сохранить' : ''"><i class="fa fa-save"></i></b-button>
</template>

<script>

export default ({
  name: "button-save",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
